import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from '../../app.component';
import * as $ from 'jquery';
import { OrderPipe } from 'ngx-order-pipe';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
    selector: 'app-circularandnotification',
    templateUrl: './circularandnotification.component.html',
    styleUrls: ['./circularandnotification.component.scss']
})
/** circularandnotification component*/
export class CircularandnotificationComponent {
  circularandnotification: any;
  route: any;
  title: any;
  itemsPerPage: number;
  Search: any;
  paginationPageNumber: number;
  circularandnotificationCount: any;
  circularandnotificationtitle: any;
  content: any;
  currentDate: any = new Date();
    MenuList: any;
  modeltitle: any;
  image: any;
  fileUrl: any;
  multipleEntry: boolean = false;
  imgUrl: any;
  circularSpinner: boolean;
  constructor(private spinner:NgxSpinnerService,private appComponent: AppComponent, private http: HttpClient, private router: Router, private datePipe: DatePipe, private orderpipe: OrderPipe) {
    this.imgUrl = window["orginalImgUrl"];
    this.fileUrl = window["getfile"];
    var str = this.router.url;
    this.route = str.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');
  }
  ngOnInit() {
    this.spinner.show();
    this.paginationPageNumber = 1;
    this.itemsPerPage = 5;
    this.getMenuName();
    this.getcircularandnotification();
    
  }

  search() {
    this.paginationPageNumber = 1;
  }

  getMenuName() {
    this.http.get(this.appComponent.APIUrl + 'MenuMaster/', {
    }).subscribe((data: any) => {
      this.MenuList = data.menuMasterDTO.filter(x => x.link == this.route);
      this.title = this.MenuList[0].title;
      this.multipleEntry = this.MenuList[0].multipleEntry;
    });
  }
  getcircularandnotification() {
    this.circularSpinner = true;
    this.http.get(this.appComponent.APIUrl + 'Post/GetPostByRoute/' + this.route, {
    }).subscribe((data: any) => {
      this.circularandnotification = data.postDTO.filter(x => x.status == 'Active' && x.displayonhome == 1);
      this.circularandnotificationCount = this.circularandnotification.length;
      this.currentDate = this.datePipe.transform(this.currentDate, 'yyyy-MM-dd' + 'T00:00:00');
      this.circularSpinner = false;
    });
  }

  itemPerPagePagination(event: any) {
    this.itemsPerPage = event.target.value;
  }
}
